module.exports = __webpack_public_path__ + "static/media/time.12b9c6d2.svg";